import React from 'react';
import { Reveal } from './Reveal';

interface SectionHeadingProps {
    eyebrow?: string;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    align?: 'center' | 'left';
    className?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    subtitle,
    align = 'center',
    className = '',
}) => {
    const alignment = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';
    return (
        <Reveal className={`flex flex-col ${alignment} ${align === 'center' ? 'max-w-2xl' : ''} ${className}`}>
            {eyebrow && (
                <span className="eyebrow mb-4">
                    <span className="h-px w-6 bg-brand-cyan/60" />
                    {eyebrow}
                </span>
            )}
            <h2 className="font-display text-3xl md:text-[2.75rem] md:leading-[1.1] font-bold text-white tracking-tight text-balance">
                {title}
            </h2>
            {subtitle && (
                <p className={`mt-5 text-text-muted text-lg leading-relaxed ${align === 'center' ? 'max-w-2xl' : 'max-w-xl'}`}>
                    {subtitle}
                </p>
            )}
        </Reveal>
    );
};

export default SectionHeading;
